var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlery1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 35C28.5641 35 35 28.5641 35 20.625C35 12.6859 28.5641 6.25 20.625 6.25C12.6859 6.25 6.25 12.6859 6.25 20.625C6.25 28.5641 12.6859 35 20.625 35Z",
    fill: "#CE2600",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 30.625C26.1479 30.625 30.625 26.1479 30.625 20.625C30.625 15.1021 26.1479 10.625 20.625 10.625C15.1021 10.625 10.625 15.1021 10.625 20.625C10.625 26.1479 15.1021 30.625 20.625 30.625Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52499 7.89092C8.04999 7.89092 7.675 8.27841 7.675 8.74091V12.1034C7.675 12.3534 7.47499 12.5409 7.23749 12.5409C6.98749 12.5409 6.8 12.3409 6.8 12.1034V8.77841C6.8 8.31591 6.4375 7.90342 5.975 7.89092C5.4875 7.87842 5.08749 8.26591 5.08749 8.74091V12.1034C5.08749 12.3534 4.8875 12.5409 4.65 12.5409C4.4 12.5409 4.2125 12.3409 4.2125 12.1034V8.77841C4.2125 8.31591 3.84999 7.90342 3.38749 7.89092C2.89999 7.87842 2.5 8.26591 2.5 8.74091V14.4659C2.5 15.594 3.04657 16.599 3.886 17.227C4.63749 17.6509 4.63749 19.5909 4.63749 19.5909V32.1159C4.63749 32.7659 5.16249 33.2909 5.81249 33.2909H6.09999C6.74999 33.2909 7.27499 32.7659 7.27499 32.1159V19.5909C7.27499 19.5909 7.27499 17.7266 8.02649 17.227C8.86591 16.599 9.4125 15.594 9.4125 14.4659V8.74091C9.3875 8.27841 8.99999 7.89092 8.52499 7.89092Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4517 7.89062C36.5767 7.89062 37.4892 8.80309 37.4892 9.92809L37.489 32.1282C37.489 32.7782 36.964 33.3032 36.314 33.3032H36.0265C35.3765 33.3032 34.8515 32.7782 34.8515 32.1282V21.3569C33.4462 20.7214 32.5392 19.3193 32.5392 17.753V10.8156C32.5267 9.20311 33.8267 7.89062 35.4517 7.89062Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery1);
export default __webpack_public_path__ + "static/media/cutlery1.7d2c6546dbe2208dec2b425f0ecf5f41.svg";
export { ForwardRef as ReactComponent };